module.exports = __webpack_public_path__ + "img/9788931009910.39142587.jpg";